import { CommunityType } from "../lib/types/enums/community/communityType";
import type { Community } from "../lib/types/schema/community/communitySchema";

export type GetIsAdminCommunityDashboardAllowedProps = {
  community: Pick<Community, "is_admin" | "type">;
};

export type GetAdminCommunityLandingPathProps = {
  community: Pick<Community, "id" | "is_admin" | "type">;
};

export const getIsAdminCommunityDashboardAllowed = ({
  community,
}: GetIsAdminCommunityDashboardAllowedProps) =>
  !(community.type === CommunityType.school && !community.is_admin);

export const getAdminCommunityLandingPath = ({
  community,
}: GetAdminCommunityLandingPathProps) =>
  `/admin/${community.id}/${
    getIsAdminCommunityDashboardAllowed({ community }) ? "dashboard" : "classes"
  }`;
